import { render, staticRenderFns } from "./UserDepartmentForm.vue?vue&type=template&id=4a9920bb"
import script from "./UserDepartmentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDepartmentForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports